export function initReadMoreRte() {
    const frames = document.querySelectorAll('.frame');
    if (!frames.length)
        return;
    frames.forEach((frame) => {
        const collapsibleSpans = frame.querySelectorAll('span.rte-collapsible');
        if (!collapsibleSpans.length)
            return;
        const elementsToHide = new Set();
        collapsibleSpans.forEach((span) => {
            const parent = span.parentElement;
            if (parent && parent !== frame) {
                elementsToHide.add(parent);
            }
            else {
                elementsToHide.add(span);
            }
        });
        // Alle collapsible-Bereiche initial ausblenden
        elementsToHide.forEach((el) => {
            el.style.display = 'none';
            el.setAttribute('aria-hidden', 'true');
        });
        // Button erstellen
        const button = document.createElement('button');
        button.className = 'btn-read-more-rte';
        button.textContent = '+ Mehr lesen';
        button.type = 'button';
        button.setAttribute('aria-expanded', 'false');
        // IDs für aria-controls
        const controlledIds = Array.from(elementsToHide).map((el, i) => {
            const id = el.id || `rte-collapsible-wrapper-${Math.random().toString(36).substr(2, 9)}-${i}`;
            el.id = id;
            return id;
        });
        button.setAttribute('aria-controls', controlledIds.join(' '));
        // Button **vor dem Parent des ersten ausgeblendeten Spans** einfügen
        const lastSpan = collapsibleSpans[collapsibleSpans.length - 1];
        console.log(lastSpan);
        const lastParent = lastSpan.parentElement && lastSpan.parentElement !== frame
            ? lastSpan.parentElement
            : lastSpan;
        if (lastParent.parentElement) {
            lastParent.after(button);
        }
        // Klick-Handler
        button.addEventListener('click', () => {
            const expanded = button.getAttribute('aria-expanded') === 'true';
            const newState = !expanded;
            elementsToHide.forEach((el) => {
                el.style.display = newState ? '' : 'none';
                el.setAttribute('aria-hidden', newState ? 'false' : 'true');
            });
            button.textContent = newState ? '- Weniger lesen' : '+ Mehr lesen';
            button.setAttribute('aria-expanded', String(newState));
        });
    });
}
